export default __webpack_public_path__ + "static/media/GoogleMaps_Logo_WithLightOutline.aba5174e.svg";